import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import DomainDetail from '../components/DomainDetail';

const DomainDetailPage: React.FC = () => {
  const { domainName } = useParams<{ domainName: string }>();

  if (!domainName) {
    return (
      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Domain Not Found</h1>
            <p className="text-gray-600 mb-6">The domain name is required to view domain details.</p>
            <Link
              to="/dashboard/portfolios"
              className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-700 transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Back to Portfolios</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Link
            to="/dashboard/portfolios"
            className="flex items-center space-x-2 text-blue-600 hover:text-blue-700 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Back to Portfolios</span>
          </Link>
          <div className="h-6 w-px bg-gray-300"></div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Domain Health</h1>
            <p className="text-gray-600">Detailed domain information and health metrics</p>
          </div>
        </div>
      </div>

      {/* Domain Detail Component */}
      <DomainDetail domainName={domainName} />
    </div>
  );
};

export default DomainDetailPage; 